<template>
  <div class="coupon-wrap">
    <template :key="item.id" v-for="(item, index) in couponList">
      <el-popover
          ref="popoverRef"
          v-model="item.popoverVisible"
          placement="bottom"
          trigger="hover"
          width="260px"
      >
        <div>
          <div>可用周期：{{ item.effectiveWeekType }}</div>
          <div>可用时段：{{ item.effectivePeriodType }}</div>
          <div>适用门店：{{ item.shopName||'全部门店' }}</div>
          <div>获取时间：{{ item.createTime||'-' }}</div>
          <el-button 
            type="text" 
            @click.stop="handleEditCoupon(item)" 
            style="padding: 0; color: #1989fa;"
            v-has="'coupons:editTime'"
          >
            编辑到期时间
          </el-button>
        </div>
        <template #reference>
          <div class="coupon-item">
            <div class="top">
              <div class="left">
                <div class="h-name" v-if="item.type==1">现金券</div>
                <div class="h-name" v-if="item.type==2">折扣券</div>
                <div class="h-name" v-if="item.type==3">兑换券</div>
              </div>
              <div class="right">
                <div class="c-name">{{ item.name }}</div>
              </div>
            </div>
            <div class="middel">
              <div class="y-price" v-if="item.type==1">{{ (item.discount).toFixed(2) }}</div>
              <div class="y-price" v-if="item.type==2">{{ (item.discount)/10 }}折</div>
              <div class="y-price" v-if="item.type==3">{{ item.serveName }}</div>
            </div>

            <div class="bottom">
              <div class="use-time">
                <template v-if="item.validityType == 1">
                  <div style="margin-bottom: 5px;">开始时间：{{ item.startDate }}</div>
                  <div>到期时间：{{ item.endDate }}</div>
                </template>
                <template v-else>
                  <template v-if="item.validityType == 2">
                    领取当天后{{ item.days }}天有效
                  </template>
                  <template v-else> 领取次日后{{ item.days }}天有效 </template>
                </template>
              </div>
            </div>
            <div class="bottoms">
              <div class="state">
                <p v-if="item.status == 1">未使用</p>
                <p v-if="item.status == 2">已使用</p>
                <p v-if="item.status == 3">已过期</p>
                <p v-if="item.status == 4">已作废</p>
                <p v-if="item.status == 5">待领取</p>
              </div>
              <template v-if="!item.hasThreshold"> 无门槛 </template>
              <template v-else>订单满 {{ item.thresholdPrice }}元可用</template>
            </div>
            <!-- 编辑按钮 -->
            <div class="edit-btn" v-has="'coupons:editTime'" @click.stop="handleEditCoupon(item)">
              <el-icon><Edit /></el-icon>
            </div>
          </div>
        </template>
      </el-popover>
    </template>
  </div>

  <!-- 修改到期时间弹窗 -->
  <el-dialog
    v-model="editDialogVisible"
    title="修改优惠券到期时间"
    width="400px"
    @close="resetEditForm"
  >
    <el-form
      ref="editFormRef"
      :model="editForm"
      :rules="editRules"
      label-width="100px"
    >
      <!-- 只保留到期时间修改 -->
      <el-form-item label="到期时间" prop="endDate">
        <el-date-picker
          v-model="editForm.endDate"
          type="date"
          placeholder="选择新的到期时间"
          value-format="YYYY-MM-DD HH:mm:ss"
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="editDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSaveEdit">保存修改</el-button>
    </template>
  </el-dialog>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
// 假设的API接口（需根据实际项目替换）
// import { updateCouponEndDate } from '@/service/coupon'
import { editUserCouponExpirationDate } from '@/service/main/customer'

export default defineComponent({
  props: {
    couponList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    Edit
  },
  emits: ['coupon-updated'],
  setup(props, { emit }) {
    // 编辑弹窗状态
    const editDialogVisible = ref(false)
    
    // 编辑表单数据（简化为只包含必要字段）
    const editForm = reactive({
      code: '', // 优惠券编码
      endDate: '' // 新的到期时间
    })
    
    // 当前编辑的优惠券
    const currentCoupon = ref(null)
    
    // 表单验证规则（只验证到期时间）
    const editRules = reactive({
      endDate: [
        { required: true, message: '请选择新的到期时间', trigger: 'change' }
      ]
    })
    
    const editFormRef = ref(null)
    
    // 处理编辑优惠券
    const handleEditCoupon = (item) => {
      currentCoupon.value = item
      editDialogVisible.value = true
      
      // 初始化表单数据
      editForm.code = item.code || item.id // 优先使用code，无则用id
      editForm.endDate = item.endDate || '' // 回显当前到期时间
      
      // 关闭当前优惠券的popover
      if (item.popoverVisible) {
        item.popoverVisible = false
      }
    }
    
    // 重置编辑表单
    const resetEditForm = () => {
      editForm.code = ''
      editForm.endDate = ''
      currentCoupon.value = null
      if (editFormRef.value) {
        editFormRef.value.clearValidate()
      }
    }
    
    // 保存修改（适配新接口参数）
    const handleSaveEdit = async () => {
      if (!editFormRef.value) return
      
      try {
        await editFormRef.value.validate()
        
        // 构建接口请求参数（仅code和endDate）
        const params = {
          code: editForm.code,
          endDate: editForm.endDate
        }
        
        // 调用API更新优惠券到期时间
        const res = await editUserCouponExpirationDate(params)
        if (res.code === 0) {
          ElMessage.success('优惠券到期时间修改成功！')
          
          // 更新本地数据
          // if (currentCoupon.value) {
          //   currentCoupon.value.endDate = editForm.endDate
          //   // 如果是按天数计算的有效期，同步更新显示逻辑（可选）
          //   if (currentCoupon.value.validityType !== 1) {
          //     // 可根据新的到期时间计算days，或提示用户类型不匹配
          //   }
          // }
          
          editDialogVisible.value = false
          resetEditForm()
          
          // 通知父组件数据更新
          emit('coupon-updated')
        } else {
          ElMessage.error(res.msg || '修改失败，请重试')
        }
      } catch (error) {
        console.error('表单验证失败:', error)
      }
    }
    
    // 初始化每个优惠券的popoverVisible属性
    watch(() => props.couponList, (newList) => {
      if (newList && newList.length) {
        newList.forEach(item => {
          if (!('popoverVisible' in item)) {
            item.popoverVisible = false
          }
        })
      }
    }, { immediate: true, deep: true })
    
    return {
      editDialogVisible,
      editForm,
      editRules,
      editFormRef,
      currentCoupon,
      handleEditCoupon,
      resetEditForm,
      handleSaveEdit
    }
  }
})
</script>

<style scoped lang="less">
.coupon-wrap {
  display: flex;
  flex-wrap: wrap;

  .coupon-item {
    min-width: 260px;
    padding: 15px 20px;
    width: 20%;
    border-radius: 10px;
    font-size: 14px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    color: #003078;
    background: url('https://yizhige.oss-cn-shanghai.aliyuncs.com/yizhige/46c78c78-fd06-4bbe-9410-b4d1e168d3b4.png') no-repeat;
    background-size: 100% 100%;
    margin: 20px 10px;
    min-height: 136px;
    position: relative;
    
    // 编辑按钮样式
    .edit-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #003078;
      opacity: 0;
      transition: opacity 0.3s;
    }
    
    &:hover .edit-btn {
      opacity: 1;
    }

    .top {
      color: #003078;
      font-weight: 500;
      display: flex;
      justify-content: space-between;

      .left {
        .h-name {
          font-size: 14px;
          font-weight: 400;
          color: #003078;
        }
      }

      .right {
        .c-name {
          font-size: 12px;
          margin-bottom: 8px;
        }
      }
    }

    .middel {
      .y-price {
        font-size: 17px;
        font-weight: 500;
        width: 220px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      bottom: 38px;
      width: 85%;
      color: #003078;
      font-size: 12px;
    }

    .bottoms {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      bottom: 10px;
      width: 85%;
      color: #003078;
      font-size: 12px;

      .state {
        display: inline-block;
        padding: 2px 6px;
        border: 1px solid #003078;
        border-radius: 14px;
      }
    }
  }
}
</style>